document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#section-nav')) {
    document.querySelector('body').setAttribute('data-bs-spy', 'scroll');
    document.querySelector('body').setAttribute('data-bs-target', '#section-nav');

    let activeWatch = true;

    function scrollSectionNav(elem) {
      sectionNav.parentElement.scrollLeft = Math.max(0, elem.offsetLeft + elem.offsetWidth / 2 - sectionNav.parentElement.offsetWidth / 2 - sectionNav.offsetLeft);
    }

    // keep the currently active list item centered as best as possible
    let sectionNav = document.querySelector('#section-nav');
    let watchActive = (list, observer) => {
      if (activeWatch) {
        list.forEach((mutation) => {
          if (mutation.attributeName == 'class' && mutation.target.classList.contains('active')) {
            scrollSectionNav(mutation.target);
          }
        })
      }
    }
    let mo = new MutationObserver(watchActive);
    sectionNav.querySelectorAll('.nav-link').forEach((nl) => {
      mo.observe(nl, { attributes: true })
      nl.addEventListener('click', (evt) => {
        activeWatch = false;
        scrollSectionNav(evt.currentTarget);
        setTimeout(() => {
          activeWatch = true;
        }, 500);
      })
    });
  }
});